import { useAtomValue } from "jotai";
import type { IServicesAtom} from "../stores/cms/productsStore";
import { ProductsCollection } from "../stores/cms/productsStore";

export function useProductsCollection(): IServicesAtom {
  const products = useAtomValue(ProductsCollection);

  return products;
}
